import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { errorHandler } from 'src/app/shared/helpers/error-handler';
import { AuthService } from 'src/app/shared/services/auth.service';


@Component({
    templateUrl: './handler-auth.component.html',
    styleUrls: ['./handler-auth.component.scss'],
})
export class HandlerAuthComponent implements OnInit {

    login: boolean = true;
    term: boolean = false
    select: boolean = false;
    change: boolean = false;
    expire: boolean = false;
    insurance: boolean = false;
    forgot: boolean = false;
    isProviderValue: boolean = false;
    isBrokerValue: boolean = false;
    listCompanyOne: any[] = [];
    listCompanyTwo: any[] = [];
    accessToken: any;
    companyId: any;
    personId: any;
    termId: any;
    termText: any;
    providerStr: any;
    insuranceStr: any = [];
    companyValue: any;
    tokenValue: any;
    document: any;
    emails: any[] = [];
    error: boolean = false;
    errorMsg: any;
    providerId: any;


    constructor(
        private spinner: NgxSpinnerService,
        private authService: AuthService,
        private toastr: ToastrService,
        private router: Router,
        private route: ActivatedRoute,
    ) { }




    async ngOnInit() {


        this.route.params.subscribe(async params => {
            const tokenId = params.tokenId;

            try {
                this.spinner.show();
                const result: any = (await this.authService.authenticateTokenExternal(tokenId)).body;

                
                this.authService.token = result.data.accessToken;

                const resultLoginUser: any = await this.authService.authenticate(null, this.authService.token);

                const insurance = resultLoginUser.body.data[0].companyPersons.length > 1 ? 
                resultLoginUser.body.data[0].companyPersons.filter(c => c.companyId == 'f00c37cc-accf-48c7-8c21-50b63f32d1c1')[0] :
                resultLoginUser.body.data[0].companyPersons[0];
                
                insurance.company.isClient = false;
                insurance.company.isBroker = true;
                insurance.company.isExternalAccess = true;
                
                window.localStorage.setItem('insurance', JSON.stringify(insurance));
                this.login = false;
                this.select = true;

                this.spinner.hide();
                this.acceptLogin();

            } catch (error) {
                this.toastr.error(errorHandler(error.error.errors[0]), 'Falha na autenticação!');
            } finally {
                this.spinner.hide();
            }
        })
    }

    acceptLogin() {
        this.router.navigate(['/cadastro/vistoria']);
    }
}